//
import { queryList, saveObject, updateObject, getAllRoleList, getAllCustomerList, getAllRdcList, getAllCarrierList, searchCarrierList, searchRdcList, getResetRoleList, getResetPwd, getDeleteUserList, getForceResetPwd, initRolePrivilegeData, getAllCustomerGroupList } from './../api';
//import { userType } from '../../../../api'
import { Message } from 'element-ui';
const user = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    userAdd: null,
    updateData: null,
    allRoleList: null,
    allRdcList: null,
    allCarrierList: null,
    initRolePrivilegeData: null,
    resetRoleList: null,
    resetPwdList: null,
    forceResetPwdList: null,
    deleteUserList: null,
    total: null,
    userTypeObj: null,
    searchCarrierResult: null,
    searchRdcResult: null,
    allCustomerGroupList: null,
  },
  mutations: {
    queryList(state, resp) {
      if (resp.code === state.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      state.total = resp.total
      state.resp = resp.obj || [];
    },
    SAVE_OBJECT(state, resp) {
      state.userAdd = resp
    },
    UP_DATE_OBJECT(state, resp) {
      state.updateData = resp
    },
    GET_ALL_ROLE_LIST(state, resp) {
      state.allRoleList = resp
    },
    GET_ALL_RDC_LIST(state, resp) {
      state.allRdcList = resp
    },
    GET_ALL_CARRIER_LIST(state, resp) {
      state.allCarrierList = resp
    },
    GET_ALL_CUSTOMER_LIST(state, resp) {
      state.allCustomerList = resp
      state.customerTotal = resp.total
    },
    GET_ALL_CUSTOMER_GROUP_LIST(state, resp) {
      state.allCustomerGroupList = resp
    },
    INIT_ROLE_PRIVILEGE_DATA(state, resp) {
      state.initRolePrivilegeData = resp
    },
    GET_RESET_ROLE_LIST(state, data) {
      state.resetRoleList = data
    },
    GET_RESET_PWD(state, data) {
      state.resetPwdList = data
    },
    GET_FORCE_RESET_PWD(state, data) {
      state.forceResetPwdList = data
    },
    GET_DELETE_USER(state, data) {
      state.deleteUserList = data
    },
    setData(state, data) {
      state[data.page] = data;
    },
    GET_ALL_USER_TYPE_LIST(state, data) {
      state.userTypeObj = data
    },
    SEARCH_CARRIER_LIST(state, data) {
      state.searchCarrierResult = data
    },
    SEARCH_RDC_LIST(state, data) {
      state.searchRdcResult = data
    },
    GET_ALL_CUSTOMER_GROUP_LIST(state, data) {
      state.allCustomerGroupList = data
    },
  },
  actions: {
    async setData({ commit }, data) {
      commit('setData', data);
    },
    async queryList({ commit }, obj) {
      let resp = await queryList(obj);
      commit('queryList', resp);
    },
    async getAddUser({ commit }, obj) {
      let resp = await saveObject(obj);
      commit('SAVE_OBJECT', resp);
    },
    async updateObject({ commit }, obj) {
      let resp = await updateObject(obj);
      commit('UP_DATE_OBJECT', resp);
    },
    async getAllRoleList({ commit }, obj) {
      let resp = await getAllRoleList(obj);
      commit('GET_ALL_ROLE_LIST', resp);
    },
    async getResetRoleList({ commit }, obj) {
      let resp = await getResetRoleList(obj);
      commit('GET_RESET_ROLE_LIST', resp);
    },
    async getResetPwd({ commit }, obj) {
      let resp = await getResetPwd(obj);
      commit('GET_RESET_PWD', resp);
    },
    async getForceResetPwd({ commit }, obj) {
      let resp = await getForceResetPwd(obj);
      commit('GET_FORCE_RESET_PWD', resp);
    },
    async getDeleteUserList({ commit }, obj) {
      let resp = await getDeleteUserList(obj);
      commit('GET_DELETE_USER', resp);
    },
    //查询rdc
    async getAllRdcList({ commit }, obj) {
      let resp = await getAllRdcList(obj);
      commit('GET_ALL_RDC_LIST', resp);
    },

    async getAllCustomerList({ commit }, obj) {
      let resp = await getAllCustomerList(obj);
      commit('GET_ALL_CUSTOMER_LIST', resp);
    },
    //角色设置弹窗:拿全量客户组 + 已选(回显历史)
    async initRolePrivilegeData({ commit }, obj) {
      let resp = await initRolePrivilegeData(obj);
      commit('INIT_ROLE_PRIVILEGE_DATA', resp);
    },
    //客户组 transfer(角色设置)
    async getAllCustomerGroupList({ commit }, obj) {
      let resp = await getAllCustomerGroupList(obj);
      commit('GET_ALL_CUSTOMER_GROUP_LIST', resp);
    },
    //查询carrier
    async getAllCarrierList({ commit }, obj) {
      let resp = await getAllCarrierList(obj);
      commit('GET_ALL_CARRIER_LIST', resp);
    },
    //搜索承运商（穿梭框用）
    async searchCarrierList({ commit }, obj) {
      let resp = await searchCarrierList(obj);
      commit('SEARCH_CARRIER_LIST', resp);
    },
    //搜索RDC（穿梭框用）
    async getAllWhList({ commit }, obj) {
      let resp = await searchRdcList(obj);
      commit('SEARCH_RDC_LIST', resp);
    },
    //搜索客户组（穿梭框用）
    async getAllCustomerGroupList({ commit }, obj) {
      let resp = await getAllCustomerGroupList(obj);
      commit('GET_ALL_CUSTOMER_GROUP_LIST', resp);
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/store/user.store.js